<div class="{{additionalClasses + ' notice-message p-1_25 font-size-20 rounded-2 bg-note'}}">
  @if (header) {
    <strong>{{ header | translate }}:&nbsp;</strong>
    }@if (message) {
    <span>{{ message | translate }}</span>
  }
  <ng-content></ng-content>
</div>
